var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 8,
    r: 4,
    stroke: "#848A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3 20V18C3 15.7909 4.79086 14 7 14H11C13.2091 14 15 15.7909 15 18V20",
    stroke: "#848A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16 10.25C15.5858 10.25 15.25 10.5858 15.25 11C15.25 11.4142 15.5858 11.75 16 11.75V10.25ZM22 11.75C22.4142 11.75 22.75 11.4142 22.75 11C22.75 10.5858 22.4142 10.25 22 10.25V11.75ZM19.75 8C19.75 7.58579 19.4142 7.25 19 7.25C18.5858 7.25 18.25 7.58579 18.25 8H19.75ZM18.25 14C18.25 14.4142 18.5858 14.75 19 14.75C19.4142 14.75 19.75 14.4142 19.75 14H18.25ZM16 11.75H22V10.25H16V11.75ZM18.25 8V14H19.75V8H18.25Z",
    fill: "#848A9B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefProvider);
export default __webpack_public_path__ + "static/media/refProvider.81034be8203cd82fdb0977538b9de4d7.svg";
export { ForwardRef as ReactComponent };